module.exports = __webpack_public_path__ + "static/media/portrait_trips.2d3f261e.jpg";